import { useEffect, useState } from 'react';

const stubEvent = (e: ClipboardEvent) => e.stopPropagation();

const useInternalCopyPaste = () => {
  const [element, setElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!element) return undefined;

    element.addEventListener('cut', stubEvent);
    element.addEventListener('copy', stubEvent);
    element.addEventListener('paste', stubEvent);

    return () => {
      element.removeEventListener('cut', stubEvent);
      element.removeEventListener('copy', stubEvent);
      element.removeEventListener('paste', stubEvent);
    };
  }, [element]);

  return setElement;
};

export default useInternalCopyPaste;
